import React from "react";
import contactoData from "../assets/contacto.json";

function ContactoPage() {
  return (
    <div>
      <section className="content-section">
        <h1>Contacto</h1>
        <p>
          {contactoData.direccion}
          <br />
          {contactoData.telefono}
          <br />
          Email:{" "}
          <a href={`mailto:${contactoData.email}`}>{contactoData.email}</a>
        </p>
      </section>
    </div>
  );
}

export default ContactoPage;
